module.exports = __webpack_public_path__ + "img/moon-25.732d3b24.svg";